export default {
  loading: false,
  proposal_dashboard: [],
  proposal_order:{},
  order_list:{},
  totalCount: 0,
  page:0,
};
